import { createSelector } from '@reduxjs/toolkit';

export const selectAccount = (state) => state.account || {};

export const selectIsAuthenticated = createSelector(
  selectAccount,
  ({ isAuthenticated }) => isAuthenticated,
);
export const selectAccountModel = createSelector(
  selectAccount,
  ({ model }) => model,
);
export const selectAccountType = createSelector(
  selectAccountModel,
  (model) => model?.account_type,
);
// export const selectAccountType = createSelector(
//   selectAccountModel,
//   (model) => model?.account_type,
// );
export const selectAccountLogin = createSelector(
  selectAccountModel,
  (model) => (model ? model.login : null),
);
